import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const StackCommerceCodeInput = () => {
  return (
    <VpHookFormInput
      maxLength={15}
      required
      name="stackCommerceCode"
      placeholder="Stack Commerce Code"
    />
  );
};

export default StackCommerceCodeInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/StackCommerceCodeInput.jsx